/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 控制级别
 */
let EnumAuthorityType = {
	Menu : new EnumItem('菜单', 2),
	Interface: new EnumItem('接口', 1),
	...enumMixn
}
export default EnumAuthorityType
